// src/glass.ts
var glassColors = {
  // The four native boot frames (app.json splash, OtaGate, Splash, reloadScreen) paint
  // this and must match app.json. White, like the app ground and the web's boot scene,
  // so the hand-off to the first screen is not a change of colour.
  bootGround: "#FFFFFF",
  pillBackground: "rgba(255, 255, 255, 0.6)",
  pillBackgroundStrong: "rgba(255, 255, 255, 0.72)",
  pillBorder: "rgba(255, 255, 255, 0.4)"
};

export {
  glassColors
};
